"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabelForStatusUpdate = exports.Expense = void 0;
const commentItem_model_1 = require("../comment/commentItem.model");
const billingPeriod_enum_1 = require("./billingPeriod.enum");
const expenseKind_enum_1 = require("./expenseKind.enum");
const expenseRequestType_enum_1 = require("./expenseRequestType.enum");
const expenseStatus_enum_1 = require("./expenseStatus.enum");
const subscriptionType_enum_1 = require("./subscriptionType.enum");
class Expense {
    constructor(data) {
        /**
         * @deprecated
         * Please use splits property of the expense.
         * All item information are now combined in splits property.
         * For items in particular, set the Expense's splitType to SplitTypeEnum.ITEM
         */
        this.items = [];
        this.isReimbursement = false;
        this.comments = [];
        // @todo to improve typings
        this.renewalsExpenses = [];
        this.approvalsForActiveWorkflowRule = [];
        this.expenseTags = [];
        this.isCurrentUserExpense = (loggedInUserId) => (this.status === expenseStatus_enum_1.ExpenseStatusEnum.PURCHASE_PENDING || this.status === expenseStatus_enum_1.ExpenseStatusEnum.INVOICE_PENDING) && this.requestedBy === loggedInUserId;
        this.isSubscription = () => this.kind === expenseKind_enum_1.ExpenseKindEnum.SUBSCRIPTION;
        this.isInitialSubscription = () => this.subscriptionType === subscriptionType_enum_1.SubscriptionTypeEnum.INITIAL_REQUEST;
        this.isAtLeastApproved = () => this.status === expenseStatus_enum_1.ExpenseStatusEnum.APPROVED || this.status === expenseStatus_enum_1.ExpenseStatusEnum.REVIEWED || this.status === expenseStatus_enum_1.ExpenseStatusEnum.PAID || this.status === expenseStatus_enum_1.ExpenseStatusEnum.DONE;
        this.isPaid = () => this.status === expenseStatus_enum_1.ExpenseStatusEnum.PAID;
        this.isProcessed = () => this.status === expenseStatus_enum_1.ExpenseStatusEnum.PAID || this.status === expenseStatus_enum_1.ExpenseStatusEnum.DONE || this.status === expenseStatus_enum_1.ExpenseStatusEnum.DECLINED;
        this.isSuccessfullyProcessed = () => this.status === expenseStatus_enum_1.ExpenseStatusEnum.PAID || this.status === expenseStatus_enum_1.ExpenseStatusEnum.DONE;
        this.isInReview = () => this.status === expenseStatus_enum_1.ExpenseStatusEnum.APPROVED;
        this.isReviewed = () => this.status === expenseStatus_enum_1.ExpenseStatusEnum.REVIEWED;
        this.isPending = () => this.status === expenseStatus_enum_1.ExpenseStatusEnum.PURCHASE_PENDING || this.status === expenseStatus_enum_1.ExpenseStatusEnum.DOCS_NEEDED || this.status === expenseStatus_enum_1.ExpenseStatusEnum.INVOICE_PENDING;
        this.cannotBeDeleted = () => this.isSubscription() && this.subscriptionType === subscriptionType_enum_1.SubscriptionTypeEnum.INITIAL_REQUEST && this.renewalsExpenses.length > 0;
        this.getRequestType = () => {
            if ([expenseKind_enum_1.ExpenseKindEnum.MILEAGE, expenseKind_enum_1.ExpenseKindEnum.HOSPITALITY, expenseKind_enum_1.ExpenseKindEnum.PER_DIEM].includes(this.kind)) {
                return expenseRequestType_enum_1.ExpenseRequestTypeEnum.REIMBURSEMENT;
            }
            else
                return this.status === expenseStatus_enum_1.ExpenseStatusEnum.PURCHASE_PENDING ? expenseRequestType_enum_1.ExpenseRequestTypeEnum.PURCHASE : expenseRequestType_enum_1.ExpenseRequestTypeEnum.INVOICE;
        };
        this.extractSubscriptionDataFromExpense = () => {
            return {
                name: this.name,
                link: this.link || '',
                description: this.description,
                datePurchased: new Date(this.datePurchased),
                dateCancellationDue: new Date(this.dateCancellationDue),
                currency: this.currency,
                subscriptionType: this.subscriptionType,
                renewalsExpenses: this.renewalsExpenses,
                billingPeriod: this.billingPeriod,
                monthlyPrice: this.monthlyPrice,
                quarterlyPrice: this.quarterlyPrice,
                yearlyPrice: this.yearlyPrice,
                parentSubscription: this.parentSubscription,
            };
        };
        this.extractOneTimeExpenseDataFromExpense = () => {
            return {
                items: this.items,
                description: this.description,
                currency: this.currency,
                isReimbursement: this.isReimbursement,
            };
        };
        this.getCurrentExpenseValue = () => {
            return this.kind === expenseKind_enum_1.ExpenseKindEnum.ONE_TIME_EXPENSE ? this.getExpenseTotalPrice() : this.getSubscriptionBillingValue();
        };
        this.getExpenseTotalPrice = () => {
            return this.items.reduce((total, current) => { var _a; return total + ((_a = current === null || current === void 0 ? void 0 : current.totalPrice) !== null && _a !== void 0 ? _a : 0); }, 0);
        };
        this.getSubscriptionBillingValue = () => {
            switch (this.billingPeriod) {
                case billingPeriod_enum_1.BillingPeriodEnum.MONTHLY:
                    return this.monthlyPrice;
                case billingPeriod_enum_1.BillingPeriodEnum.QUARTERLY:
                    return this.quarterlyPrice;
                case billingPeriod_enum_1.BillingPeriodEnum.YEARLY:
                    return this.yearlyPrice;
                default:
            }
            return this.yearlyPrice;
        };
        this.addDateFields = () => (Object.assign(Object.assign({}, this), { year: new Date(this.datePurchased).getFullYear(), month: new Date(this.datePurchased).getMonth() }));
        if (data) {
            this.deserialize(data);
        }
    }
    deserialize(input) {
        var _a, _b, _c;
        Object.assign(this, input);
        this.id = input.id || input._id;
        this.items = ((_a = input.items) === null || _a === void 0 ? void 0 : _a.map((item) => item)) || [];
        this.splits = ((_b = input.splits) === null || _b === void 0 ? void 0 : _b.map((split) => split)) || [];
        this.comments = ((_c = input.comments) === null || _c === void 0 ? void 0 : _c.map((comment) => new commentItem_model_1.CommentItem(comment))) || [];
        this.invoices = (input === null || input === void 0 ? void 0 : input.invoices) || [];
        this.totalGrossPrice = (input === null || input === void 0 ? void 0 : input.totalGrossPrice) || 0;
        return this;
    }
}
exports.Expense = Expense;
exports.getLabelForStatusUpdate = (StatusCode) => {
    switch (StatusCode) {
        case expenseStatus_enum_1.ExpenseStatusEnum.APPROVED:
        case expenseStatus_enum_1.ExpenseStatusEnum.DOCS_NEEDED:
            return 'approved';
        case expenseStatus_enum_1.ExpenseStatusEnum.DECLINED:
            return 'rejected';
        case expenseStatus_enum_1.ExpenseStatusEnum.REVIEWED:
            return 'reviewed';
        case expenseStatus_enum_1.ExpenseStatusEnum.PAID:
            return 'paid';
        case expenseStatus_enum_1.ExpenseStatusEnum.DONE:
            return 'exported';
        default:
            return '';
    }
};
